import { CompactUser } from 'src/context/user';
import { HAS_SEEN_PRONUNCIATION_UPSELL_STORAGE_KEY } from 'src/constants/storageKeys.const';
import {
  addToLocalStorageArrayEntry,
  hasInLocalStorageArrayEntry,
} from 'src/utils/webStorageArrayUtils';

export const canShowPronunciationUpsell = (user: CompactUser | null): boolean => {
  if (!user || user.isPro) return false;

  return !hasInLocalStorageArrayEntry(HAS_SEEN_PRONUNCIATION_UPSELL_STORAGE_KEY, String(user.id));
};

export const markPronunciationUpsellShown = (user: CompactUser | null): void => {
  if (!user) return;

  addToLocalStorageArrayEntry(HAS_SEEN_PRONUNCIATION_UPSELL_STORAGE_KEY, String(user.id));
};
